import { useLayoutEffect, useMemo, useState } from 'react'

import { QuestShortDetails } from '@store'

import styles from './Quests.module.scss'
import { DotCircle } from './components/DotCircle'
import { QuestCircle } from './components/QuestCircle'
import { getQuestLayoutForPage } from './questCircleLayout'
import { QuestViewState } from './types/QuestCircleTypes'

type Props = {
  isAnimated?: boolean
  pageIndex?: number
}

const COUNT_DOTS = 5
const QUESTS_PER_SCENE = 3

const createPlaceholderQuest = (index: number): QuestShortDetails => ({
  id: -1 - index,
  slug: '',
  image: '',
  isSolved: false,
  isAvailable: false,
  type: 'major',
  starsCollected: 0,
  starsTotal: 0
})

export const QuestsFallback = ({
  isAnimated = false,
  pageIndex = 0,
}: Props) => {
  const [visible, setVisible] = useState(false)

  const placeholderQuests = useMemo(() => {
    return Array.from({ length: QUESTS_PER_SCENE }, (_, index) =>
      createPlaceholderQuest(index)
    )
  }, [])

  const onQuestClick = () => {}

  useLayoutEffect(() => {
    setTimeout(() => {
      setVisible(true)
    }, 1500)
  }, [])

  return (
    <div className={styles.scene}>
      {Array.from({ length: COUNT_DOTS }).map((_, index) => (
        <DotCircle
          key={index}
          dotPosition={((index + 1) % 6) as 1 | 2 | 3 | 4 | 5}
          visible={visible}
          pageIndex={pageIndex}
        />
      ))}
      {placeholderQuests.map((quest, index) => {
        const layoutIndex = (index + 1) % 3 || 3
        return (
          <QuestCircle
            key={quest.id}
            layoutConfig={getQuestLayoutForPage(pageIndex, layoutIndex)}
            quest={quest}
            visible={visible}
            initialState={QuestViewState.Closed}
            isAnimated={isAnimated}
            pageIndex={pageIndex}
            onClick={onQuestClick}
            questCircleOpacity={1}
          />
        )
      })}
    </div>
  )
}
